import { ref, onMounted, onUnmounted, watch, getCurrentInstance } from 'vue';

export function useUserActivity(idleTimeout = 10, countdownTime = 5) {
  const { proxy } = getCurrentInstance();
  const $router = proxy.$router;
  const $route = proxy.$route;
  const $auth = proxy.$auth;
  // const router = useRouter();

  const timer = ref(countdownTime);
  const isLocked = ref(false);
  const showSnackbar = ref(false);

  let idleTimeoutInstance = null;
  let countdownIntervalInstance = null;
  let countdownStartTime = null;

  // --- Funções Internas ---

  const startIdleTimer = () => {
    idleTimeoutInstance = setTimeout(() => {
      showSnackbar.value = true;
      startCountdown();
    }, idleTimeout * 1000);
  };

  const startCountdown = () => {
    console.log('Starting countdown...');
    countdownStartTime = Date.now(); // Marca o tempo de início da contagem
    
    countdownIntervalInstance = setInterval(() => {
      const currentTime = Date.now();
      const elapsedTime = Math.floor((currentTime - countdownStartTime) / 1000); // Tempo decorrido em segundos
      const remainingTime = countdownTime - elapsedTime;
      
      if (remainingTime > 0) {
        timer.value = remainingTime;
        // console.log(`Tempo restante: ${remainingTime} segundos`);
      } else {
        clearInterval(countdownIntervalInstance);
        isLocked.value = true;
        console.log('Session locked due to inactivity.');
        const user = $auth.getUser();

        const currentPath = $route.path;
        console.log(`Rota atual: ${currentPath}`);
        $auth.logout();
        $router.push(`/login?user=${user.email}&redirect=${currentPath}`);
      }
    }, 1000);
  };

  const resetTimer = () => {
    clearTimeout(idleTimeoutInstance);
    clearInterval(countdownIntervalInstance);
    timer.value = countdownTime;
    showSnackbar.value = false;
    countdownStartTime = null; // Reset do timestamp
    startIdleTimer();
  };

  const handleUserActivity = ($event) => {
    if ($event.type !== 'mousemove') {
     console.log('User activity detected');
    }
    // if (showSnackbar.value) {
      resetTimer();
    // }
  };

  // --- Lifecycle Hooks para o Hook ---

  onMounted(() => {
    // Adiciona event listeners ao montar o componente
    window.addEventListener('mousemove', handleUserActivity);
    window.addEventListener('keypress', handleUserActivity);
    window.addEventListener('click', handleUserActivity);
    window.addEventListener('touchstart', handleUserActivity);
    startIdleTimer();
  });

  onUnmounted(() => {
    // Remove event listeners e limpa timers ao desmontar o componente
    window.removeEventListener('mousemove', handleUserActivity);
    window.removeEventListener('keypress', handleUserActivity);
    window.removeEventListener('click', handleUserActivity);
    window.removeEventListener('touchstart', handleUserActivity);
    clearTimeout(idleTimeoutInstance);
    clearInterval(countdownIntervalInstance);
  });

  // Watcher para resetar o timer quando a rota muda (exceto para a tela de bloqueio)
  watch(
    () => $route.path,
    (newPath) => {
      if (newPath !== '/locked' && isLocked.value) {
        isLocked.value = false;
        resetTimer();
      }
    }
  );

  return { timer, showSnackbar, isLocked, resetTimer };
}